import { useContext } from 'react'
import {LoadingContext} from "../context/loading/LoadingContext";

export const useLoading = () => {
    const { isLoading, showGlobalLoading, hideGlobalLoading } = useContext(LoadingContext);

    const showLoading = () => {
        showGlobalLoading();
    }

    const hideLoading = () => {
        hideGlobalLoading();
    }

    return { isLoading, showLoading, hideLoading }
}